import { AddCircleFilled } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React from 'react';
import { Button } from "../button/Button.js";
import { Spinner } from "../spinner/Spinner.js";
import { Typography } from "../typography/Typography.js";
import styles from "./AddButton.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AddButton({
  name,
  description,
  isLoading,
  disabled,
  variant,
  className,
  ...props
}) {
  const hasDescription = !!description;
  const classes = classNames(styles.addButton, styles[variant], {
    [styles.hasDescription]: hasDescription
  }, {
    [styles.disabled]: disabled
  }, className);
  if (variant === 'CONDENSED') {
    const iconLeft = isLoading ? /*#__PURE__*/_jsx(Spinner, {
      size: 24,
      className: styles.spinnerCondensed
    }) : AddCircleFilled;
    return /*#__PURE__*/_jsx(Button, {
      ...props,
      className: className,
      variant: "text",
      secondary: true,
      iconLeft: iconLeft,
      disabled: disabled,
      children: name
    });
  }
  return /*#__PURE__*/_jsxs("button", {
    className: classes,
    type: "button",
    "data-variant": variant,
    disabled: disabled,
    ...props,
    children: [/*#__PURE__*/_jsxs("span", {
      className: styles.addAction,
      children: [isLoading ? /*#__PURE__*/_jsx(Spinner, {
        size: variant === 'VERTICAL_BOX' ? 40 : 24,
        className: styles.addAction
      }) : /*#__PURE__*/_jsx(AddCircleFilled, {
        className: styles.icon,
        size: variant === 'VERTICAL_BOX' ? 40 : undefined
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "strong",
        className: styles.headline,
        children: name
      })]
    }), hasDescription && /*#__PURE__*/_jsx("span", {
      className: styles.description,
      children: description
    })]
  });
}